import React from "react";
import styles from "./LevelUpModal.module.css";

const LevelUpModal = ({ isOpen, level, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.particles} />
                <div className={styles.content}>
                    <div className={styles.glow} />
                    <h2 className={styles.title}>LEVEL UP!</h2>
                    <div className={styles.levelCircle}>
                        <span className={styles.levelText}>{level}</span>
                    </div>
                    <p className={styles.message}>
                        Congratulations! You've reached a new tier of pixel power.
                    </p>
                    <button className={styles.closeButton} onClick={onClose}>
                        Awesome!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LevelUpModal;
